import React from "react";

import Button from "components/Button";
import { Container, Masonry } from "components/Grid";

import Article from "./Article";

import { Wrapper } from "./styles";

class PressReleases extends React.Component {
  state = {
    isLimited: true
  };

  toggleList = () => {
    this.setState(state => ({ isLimited: !state.isLimited }));
  };

  render() {
    const { isLimited } = this.state;
    const { content } = this.props;

    const breakpoints = {
      default: 3,
      1100: 2,
      700: 1
    };

    const articles = isLimited ? content.slice(0, 7) : content;

    return (
      <Container bg="white">
        <Wrapper mt="-100px" mb="100px">
          <Masonry breakpointCols={breakpoints}>
            {articles.map((article, index) => (
              <Article content={article} key={index} />
            ))}
          </Masonry>
          <Container>
            {content.length > 7 && (
              <Button m="40px auto" onClick={this.toggleList}>
                {isLimited ? "View all Articles" : "Show fewer Articles"}
              </Button>
            )}
          </Container>
        </Wrapper>
      </Container>
    );
  }
}

export default PressReleases;
